/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { forwardRef } from "react";

export type AccordionContentProps = AccordionPrimitive.AccordionContentProps;

export const AccordionContent = forwardRef<any, AccordionContentProps>(({ ...props }, forwardedRef) => (
	<AccordionPrimitive.Content {...props} ref={forwardedRef} />
));

AccordionContent.displayName = "Accordion.Content";
